import React, { useState } from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import EditModal from '#app/View/InventoryManagement/Deposit/Picking/components/EditModal';
import List from '#app/View/InventoryManagement/Deposit/Picking/components/List';
import Search from '#app/View/InventoryManagement/Deposit/Picking/components/Search';
import DepositByProductEntryPoints from '#app/entrypoints/depositByProduct';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { DepositByProductPicking } from '#app/typings/depositByProduct';

export type Filters = {
  deposit?: number;
  byProduct?: number;
  pickingLocation?: string;
  storage?: string;
};

const Picking: React.FC = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [currentPicking, setCurrentPicking] = useState<DepositByProductPicking>();
  const { setFilters, filters, mutate, ...props } = useCollectionPaginated<DepositByProductPicking, Filters>(
    DepositByProductEntryPoints.getCollectionPicking,
    { sorting: { sortName: 'pickingLocation', sortDirection: 'asc' }, filters: { deposit: 1 } },
  );

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des pickings', context: 'Gestion des stocks' }}>
      <Search filters={filters} handleSearch={(data) => setFilters(data)} />
      <List
        {...props}
        mutate={mutate}
        onEdit={(item) => {
          setOpenModal(true);
          setCurrentPicking(item);
        }}
      />
      {openModal && (
        <EditModal
          deposit={filters.deposit as number}
          item={currentPicking}
          onClose={() => {
            mutate();
            setOpenModal(false);
          }}
        />
      )}
    </ContentViewComponent>
  );
};

export default Picking;
